import Vue from 'vue'
import Router from 'vue-router'
import i18n from '../i18n'
import moment from 'moment'
import localStorage from '../plugins/localstorage'
import linehaul from './linehaul'
import defaultRoutes from './default'
import Qs from 'qs'
import nordjyske from './nordjyske'
import shop from './shop'

const host = window.location.host
const parts = host.split('.')
Vue.use(Router)

const getRoutes = () => {
    const domain = parts[0]

    switch (domain) {
        case 'linehaul':
        case 'linehauldev': {
            return linehaul
        }
        case 'nordjyske': {
            return nordjyske
        }

        case 'shop': {
            return shop
        }

        default: {
            return defaultRoutes
        }
    }
}

const router = new Router({
    stringifyQuery: (query) => {
        const result = Qs.stringify(query, { arrayFormat: 'brackets' })

        return result ? (`?${result}`) : ''
    },
    parseQuery (query) {
        return Qs.parse(query)
    },
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/pages',
            component: () => import('@/views/pages/Index'),
            children: [
            {
                name: 'Logout',
                path: 'logout',
                component: () => import('@/views/pages/Logout'),
            },
            {
                name: 'Login',
                path: 'login',
                component: () => import('@/views/pages/Login'),
            },
            {
              name: 'LoginOld',
              path: 'login-old',
              component: () => import('@/views/pages/LoginOld'),
          },
            {
                name: 'Register',
                path: 'register',
                component: () => import('@/views/pages/Register'),
            },
            ],
        },
        { ...getRoutes() },
        {
            path: '*',
            component: () => import('@/views/pages/Index'),
            children: [
              {
                name: '404 Error',
                path: '',
                component: () => import('@/views/pages/Error'),
              },
            ],
          },
    ],
})

router.beforeEach((to, from, next) => {
    if (to.path === '/logout') {
        next({
            name: 'Logout',
        })
    } else if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!localStorage.get('token')) {
            next({
                name: 'Login',
                params: { nextUrl: to.fullPath },
            })
        } else {
            const user = JSON.parse(localStorage.get('user') || '{}')
            if (to.matched.some(record => record.meta.superuser)) {
                if (user?.role >= 90) {
                    next()
                } else {
                    Vue.prototype.$toast(i18n.t('not_permission_view'), { color: 'red' })
                    next({ name: 'Dashboard' })
                }
                if (user?.email?.includes('@coolrunner.dk') || user?.email?.includes('@homerunner.com')) {
                    next()
                } else {
                    Vue.prototype.$toast(i18n.t('not_permission_view'), { color: 'red' })
                    next({ name: 'Dashboard' })
                }
            } else {
                next()
            }
        }
    } else if (to.matched.some(record => record.meta.guest)) {
        if (localStorage.get('token') == null) {
            next()
        } else {
            next({ name: 'Login' })
        }
    } else {
        next()
    }
})

export default router
